import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ 
  selectedPeriod, 
  onPeriodChange,
  selectedMetric,
  onMetricChange,
  onExport
}) => {
  const periods = [
    { value: '7d', label: '7 Days' },
    { value: '30d', label: '30 Days' },
    { value: '90d', label: '90 Days' },
    { value: '1y', label: '1 Year' },
    { value: 'all', label: 'All Time' }
  ];

  const metrics = [
    { value: 'all', label: 'All Metrics', icon: 'BarChart3' },
    { value: 'strength', label: 'Strength', icon: 'Dumbbell' },
    { value: 'cardio', label: 'Cardio', icon: 'Heart' },
    { value: 'body', label: 'Body Comp', icon: 'User' },
    { value: 'nutrition', label: 'Nutrition', icon: 'Apple' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-md">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex-1">
          <label className="block text-sm font-medium text-foreground mb-2">
            Time Period
          </label>
          <div className="flex flex-wrap gap-2">
            {periods?.map((period) => (
              <button
                key={period?.value}
                onClick={() => onPeriodChange(period?.value)}
                className={`
                  px-3 py-2 rounded-lg text-sm font-medium transition-smooth press-scale
                  ${selectedPeriod === period?.value
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'bg-muted text-foreground hover:bg-muted/80'
                  }
                `}
              >
                {period?.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex-1">
          <label className="block text-sm font-medium text-foreground mb-2">
            Metric Type
          </label>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
            {metrics?.map((metric) => (
              <button
                key={metric?.value}
                onClick={() => onMetricChange(metric?.value)}
                className={`
                  flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
                  transition-smooth press-scale
                  ${selectedMetric === metric?.value
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'bg-muted text-foreground hover:bg-muted/80'
                  }
                `}
              >
                <Icon name={metric?.icon} size={16} />
                <span className="hidden md:inline">{metric?.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="lg:self-end">
          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
            className="w-full lg:w-auto"
          >
            Export Data
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;